import {Dispatch} from "react";
import {TChangeMyListActions} from "../actions/changeMyListDataActions";
import {ActionType} from "../actionTypes/actionTypes";

export const changeMyListData = (isChange: boolean) => {
    return async (dispatch: Dispatch<TChangeMyListActions>) => {
        dispatch({
            type: ActionType.CHANGE_MY_LIST_DATA,
            payload: isChange,
        });
    };
};